import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getCertificados,
  deleteCertificado,
  changeStatusCertificado,
  changeOrderCertificado,
} from "../../../../api/certificado";
import { Button, Tooltip, Switch, FormControlLabel, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";
import { getLocalidades } from "../../../../api/localidad";
import { getNonEmpty } from "../../../../utils/helpers";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  VerifiedUser,
} from "@material-ui/icons";
import { Verified } from "lucide-react";
import { SERVER_URL } from "../../../../api";

function getData(certificados) {
  let data = [];
  for (let i = 0; i < certificados.length; ++i) {
    const elem = {};
    elem.image = {
      isOwn: certificados[i].isOwn,
      image: certificados[i].imageUrl,
    };
    elem.id = certificados[i]._id;
    elem.active = certificados[i].active;
    elem.order = certificados[i].order;
    elem.link = certificados[i].link;
    data = data.concat(elem);
  }
  data.sort((a, b) => a.order - b.order);
  return data;
}

const initialFilters = {
  active: false,
};

export default function CertificadosPage() {
  const [data, setData] = useState([]);
  const [certificadoId, setCertificadoId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refreshOrder, setRefreshOrder] = useState(false);

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  async function cambiarOrden(cell, newOrder) {
    await changeOrderCertificado(cell, newOrder);
  }
  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    const handleSubtract = () => {
      setData((prevFilteredData) => {
        const currentCertificado = prevFilteredData.find(
          (certificado) => certificado._id === cell
        );
        if (!currentCertificado || currentCertificado.order === 0)
          return prevFilteredData;

        const newOrder = currentCertificado.order - 1;
        cambiarOrden(currentCertificado._id, newOrder);

        const certificadoToSwap = prevFilteredData.find(
          (certificado) => certificado.order === newOrder
        );

        return prevFilteredData.map((certificado) => {
          if (certificado._id === cell) {
            return { ...certificado, order: newOrder };
          }
          if (certificadoToSwap && certificado._id === certificadoToSwap._id) {
            return { ...certificado, order: currentCertificado.order };
          }
          return certificado;
        });
      });
      setRefreshOrder(true);
    };

    const handleAdd = () => {
      setData((prevFilteredData) => {
        const currentCertificado = prevFilteredData.find(
          (certificado) => certificado._id === cell
        );
        if (
          !currentCertificado ||
          currentCertificado.order === prevFilteredData.length - 1
        )
          return prevFilteredData;

        const newOrder = currentCertificado.order + 1;
        cambiarOrden(currentCertificado._id, newOrder);
        const certificadoToSwap = prevFilteredData.find(
          (certificado) => certificado.order === newOrder
        );

        return prevFilteredData.map((certificado) => {
          if (certificado._id === cell) {
            return { ...certificado, order: newOrder };
          }
          if (certificadoToSwap && certificado._id === certificadoToSwap._id) {
            return { ...certificado, order: currentCertificado.order };
          }
          return certificado;
        });
      });
      setRefreshOrder(true);
    };

    return (
      <>
        <Tooltip title={"Up"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleSubtract}
            disabled={elem?.order === 0}
          >
            <KeyboardArrowUp />
          </Button>
        </Tooltip>
        <Tooltip title={"Down"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleAdd}
            disabled={elem?.order === data.length - 1}
          >
            <KeyboardArrowDown />
          </Button>
        </Tooltip>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-certificado/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCertificadoId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setCertificadoId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  function imageFormatter(isOwn, imageURL) {
    let src = isOwn ? `${SERVER_URL}/${imageURL}` : imageURL;
    return imageURL ? <img src={src} width={50}></img> : <div></div>;
  }

  const columns = [
    {
      dataField: "image",
      text: "Image",
      formatter: (image) => imageFormatter(image.isOwn, image.image),
    },
    { dataField: "link", text: "Link" },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getCertificados();
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setRefresh(false);
        }
      } catch (error) {
        alertError({
          error: error,
          customMessage: "Could not get certificados.",
        });
        history.push("/dashboard");
      }
    };
    fetch();
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}>
              {/* Switches a la izquierda */}
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "30px" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={filterOptions.active ? "Solo activos" : "Todos (activos/inactivos)"}
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{ 
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px"
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{ 
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a"
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista de certificados">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-certificado")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {!refresh && !refreshOrder && (
            <Table data={getData(data)} columns={columns} />
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              certificadoId?.active ? "disable" : "enable"
            } this certificado?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusCertificado(certificadoId._id, !certificadoId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        certificadoId?.active ? "Disabled!" : "Enabled!"
                      }`,
                      customMessage: `User type ${
                        certificadoId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      certificadoId?.active ? "disable" : "enable"
                    } certificado.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this certificado?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteCertificado(certificadoId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Certificado removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove certificado.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
